import styles from './InvoiceHeader.module.scss';
import { useBranding } from '@/providers/Branding.provider';
import { Box } from 'vopay';

interface InvoiceHeaderProps {
  invoiceField?: React.ReactNode;
  name: string;
  address?: string;
}

const InvoiceHeader: React.FC<InvoiceHeaderProps> = ({ invoiceField, name, address }) => {
  const { logo } = useBranding();
  return (
    <div className={styles.invoiceHeader}>
      <Box flx="col" gapSize="8px">
        <div className={styles.name}>{name}</div>
        {address && <div className={styles.address}>{address}</div>}
      </Box>
      <Box flx="col" gapSize="10px" jc="fe">
        <img className={styles.logo} src={logo} alt="logo" />

        {invoiceField && <div className={styles.invoiceField}>{invoiceField}</div>}
      </Box>
    </div>
  );
};

export default InvoiceHeader;
